export const STATUS_WEBSOCKET_ATTEMPTING_TO_CONNECT = "ATTEMPTING_TO_CONNECT";
export const STATUS_WEBSOCKET_CONNECTED = "CONNECTED";
export const STATUS_WEBSOCKET_ERROR = "ERROR";
export const STATUS_WEBSOCKET_CLOSED = "CLOSED";
export const STATUS_WEBSOCKET_NOT_CONNECTED = "NOT_CONNECTED";
